import { StarterPackageItemVO } from "./StarterPackageItemVO";

export class StarterPackageVO {
    public id: number = 0;
    public active: boolean = false;
    public name: string;
    public items: StarterPackageItemVO[];
    public chips: number = NaN;
    public goldCosts: number = NaN;

    /** Contains only the ids of the starterPackage's boosters **/
    public boosterIds: number[];

    public toString(): string {
        return "id: " + this.id + ", active: " + this.active + ", name: " + this.name + ", items: [ " + this.items.toString() + " ], chips: " + this.chips + ", boosterIds: [ " + this.boosterIds + " ], goldCosts: " + this.goldCosts;
    }
}
